import CommunityEditorLayout from "./CommunityEditorLayout";

export default CommunityEditorLayout;
